import './NotFound.css';

import React from 'react'

function NotFound() {
    return (
        <div className="no_records_found">
            <div className="container  center">
                <h2><i className="fa fa-meh-o"></i> Oops!</h2>
                <p>We can't find the page you're looking for. Try browsing from <a href="/home">home page</a>.</p>
            </div>
        </div>
    )
}

export default NotFound
